module.exports =
  'ACCOUNT':
    'NO_NAME': 'No Name'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/account/i18n/en.coffee